import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import React, { useState, useRef, useEffect, useContext } from 'react';
import { FaStopCircle, FaPlayCircle } from "react-icons/fa";
import { Link, useNavigate, useLocation } from 'react-router-dom';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import HomeIcon from '@mui/icons-material/Home';
import EditIcon from '@mui/icons-material/Edit';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import Person4Icon from '@mui/icons-material/Person4';
import LifeInJapan from './LifeInJapan';
import axios from 'axios';
import { ProductContext } from "../context/AppContext";
import Footer from './Common_Components/Footer';
const ModuleSkit = () => {

  const navigate = useNavigate();
  const location = useLocation();
  const [activePage, setActivePage] = useState("");
  const [isBackgroundPlaying, setIsBackgroundPlaying] = useState(false);
  const [isPeoplePlaying, setIsPeoplePlaying] = useState(false);
  const [isGlossaryPlaying, setIsGlossaryPlaying] = useState(false);
  const authToken = localStorage.getItem("AuthToken");
  const audioRef = useRef(null);
  const scrollViewRef = useRef(null);
  // const { categoryId, dayId, dayName, skitname, dayLen } = route.params;
  const ModuleSkit1 = location.state;
  const categoryId = ModuleSkit1?.categoryId;
  const dayId = ModuleSkit1?.dayId;
  const unique_day_id = ModuleSkit1?.unique_day_id || ModuleSkit1?.ModuleId || ModuleSkit1?.dayId;
  const dayName = ModuleSkit1?.dayName;
  const skitname = ModuleSkit1?.skitname;
  const dayLen = ModuleSkit1?.dayLen;
  const LearningId = ModuleSkit1?.LearningId || localStorage.getItem("LearningId");
  const screenTitleId = ModuleSkit1?.screenTitleId || localStorage.getItem("screenTitleId");
  const examId = ModuleSkit1?.examId || localStorage.getItem("examId");
  console.log("skit Screen Data :", categoryId);
  console.log("skit Screen Data :", dayId);
  const { Translate } = useContext(ProductContext);

  const [skitData, setSkitData] = useState([]);
  const [currentAudio, setCurrentAudio] = useState(null);
  // const [isPlaying, setIsPlaying] = useState(false);
  const [currentSkitIndex, setCurrentSkitIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [backgroundAudio, setBackgroundAudio] = useState(null);
  // const [isBackgroundPlaying, setIsBackgroundPlaying] = useState(false);
  const [voiceAudio, setVoiceAudio] = useState(null);
  const [isVoicePlaying, setIsVoicePlaying] = useState(false);
  const currentAudioRef = useRef(null);
  const [language, setLanguage] = useState('english');
  const [text, setText] = useState({});
  const [isLoading, setIsLoading] = useState(false);


  // New state variables for image and glossary content
  const [imageIndex, setImageIndex] = useState(0);
  const [imageSrc, setImageSrc] = useState(`${process.env.PUBLIC_URL}/assets/images/ohayou.jpg`);

  const [showNewButtons, setShowNewButtons] = useState(false); // To control visibility of new buttons
  const [isPlaying, setIsPlaying] = useState(false);

  const StartQuiz = () => {
    navigate('/StartQuiz');
  };
  const LifeInJapan = () => {
    navigate('/LifeInJapan');
  };
  // Refs for audio elements

  useEffect(() => {
    const loadLanguage = async () => {
      try {
        const storedLanguage = await localStorage.getItem('selectedLanguage');
        setLanguage(storedLanguage || 'english');
      } catch (error) {
        console.error('Error loading language:', error);
      }
    };

    loadLanguage();
  }, []);

  // useEffect(() => {
  //   setText(translations[language]);
  // }, [language]);

  useEffect(() => {
    const getSkit = async () => {
      try {
        const response = await axios.get(
          `https://api.japaking.online/api/skit?dayId=${dayId}${categoryId ? `&categoryId=${categoryId}` : ""
          }`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );

        if (response.data.success) {
          setSkitData(response?.data?.message?.skitCategories);
        }
      } catch (err) {
        if (err.response && err.response.status === 401) {
          console.log('navigate to login due to 401');
          navigate('Home');
        }
        console.log(err);
      } finally {
        setLoading(false);
      }
    };
    getSkit();
  }, [categoryId, dayId]);

  const handleNext = () => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
      if (currentSkitIndex < skitData.length - 1) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth', // Optional: Adds a smooth scrolling effect
        });
        stopAudio();
        setCurrentSkitIndex(currentSkitIndex + 1);
        scrollViewRef.current?.scrollTo({ y: 0, animated: true });
      }
    }, 1000);
  };

  const playAudio = async (audioUrl) => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause(); // Pause the audio
        setIsPlaying(false); // Update state
      }

      else {
        audioRef.current.play() // Play the audio
          .then(() => {
            setIsPlaying(true); // Update state when audio starts playing
          })
          .catch((error) => {
            console.error('Error playing audio:', error); // Error handling
            setIsPlaying(false);
          });
      }
    } else {
      // If audioRef is not set, initialize it here
      const audio = new Audio(audioUrl); // Create a new Audio object
      audioRef.current = audio;

      audio.play() // Play the audio
        .then(() => {
          setIsPlaying(true); // Update state when audio starts playing
        })
        .catch((error) => {
          console.error('Error playing audio:', error); // Error handling
          setIsPlaying(false);
        });

      // Handle when the audio ends
      audio.onended = () => {
        setIsPlaying(false); // Reset state when audio ends
      };
    }
  };

  const stopAudio = () => {
    if (currentAudioRef.current) {
      currentAudioRef.current.stop(() => {
        setIsPlaying(false);
        setIsBackgroundPlaying(false);
        setIsVoicePlaying(false);
      });
      currentAudioRef.current = null;
    }
  };

  useEffect(() => {
    return () => {
      stopAudio();
    };
  }, []);

  const toggleSound = (
    audioUrl,
    audioState,
    setAudioState,
    isPlayingState,
    setIsPlayingState,
  ) => {
    if (isPlayingState) {
      if (audioState) {
        audioState.pause();
        setIsPlayingState(false);
      }
    } else {
      if (audioState) {
        audioState.play(success => {
          if (!success) {
            console.log('Sound playback failed');
          }
          setIsPlayingState(false);
        });
        setIsPlayingState(true);
      } else {
        playAudio(audioUrl, setAudioState, setIsPlayingState, isPlayingState);
      }
    }
  };

  useEffect(() => {
    const handleAppStateChange = nextAppState => {
      if (nextAppState === 'background' || nextAppState === 'inactive') {
        stopAudio();
      }
    };

    // AppState.addEventListener('change', handleAppStateChange);

    return () => {
      // AppState.removeEventListener('change', handleAppStateChange);
      stopAudio();
    };
  }, []);

  const handlePlayPause = (audioUrl, textId) => {
    if (currentAudio && currentAudio.textId === textId) {
      // Pause the current audio if the same one is clicked
      currentAudio.audio.pause();
      setCurrentAudio(null);
      setIsPlaying(false);
    } else {
      // Stop any currently playing audio
      if (currentAudio?.audio) {
        currentAudio.audio.pause();
      }

      // Create and play the new audio
      const newAudio = new Audio(audioUrl);
      newAudio.play();

      setCurrentAudio({ audio: newAudio, textId });
      setIsPlaying(true);
    }
  };





  const currentSkit = skitData[currentSkitIndex];
  const isLastSkit = currentSkitIndex === skitData.length - 1;


  const backgroundAudioRef = useRef(null);
  const peopleAudioRef = useRef(null);
  const glossaryAudioRef = useRef(null);

  // Toggle play/pause for background voice
  const toggleBackgroundPlayPause = () => {
    if (isPeoplePlaying) {
      peopleAudioRef.current.pause();
      setIsPeoplePlaying(false);
    }

    if (isGlossaryPlaying) {
      glossaryAudioRef.current.pause();
      setIsGlossaryPlaying(false);
    }

    if (isBackgroundPlaying) {
      backgroundAudioRef.current.pause();
    } else {
      backgroundAudioRef.current.play();
    }
    setIsBackgroundPlaying(prev => !prev);
  };

  // Toggle play/pause for people's voice
  const togglePeoplePlayPause = () => {
    if (isBackgroundPlaying) {
      backgroundAudioRef.current.pause();
      setIsBackgroundPlaying(false);
    }

    if (isGlossaryPlaying) {
      glossaryAudioRef.current.pause();
      setIsGlossaryPlaying(false);
    }

    if (isPeoplePlaying) {
      peopleAudioRef.current.pause();
    } else {
      peopleAudioRef.current.play();
    }
    setIsPeoplePlaying(prev => !prev);
  };

  // Toggle play/pause for glossary audio
  const toggleGlossaryPlayPause = () => {
    if (isBackgroundPlaying) {
      backgroundAudioRef.current.pause();
      setIsBackgroundPlaying(false);
    }

    if (isPeoplePlaying) {
      peopleAudioRef.current.pause();
      setIsPeoplePlaying(false);
    }

    if (isGlossaryPlaying) {
      glossaryAudioRef.current.pause();
    } else {
      glossaryAudioRef.current.play();
    }
    setIsGlossaryPlaying(prev => !prev);
  };

  // Handle the "Next Day" button click
  // const handleNextDay = () => {
  //   // Move to the next content in the list
  //   const nextIndex = (imageIndex + 1) % contentList.length;
  //   setImageIndex(nextIndex);

  //   // Update the image and glossary
  //   setImageSrc(contentList[nextIndex].image);
  //   setGlossary(contentList[nextIndex].glossary);

  //   // Show the new buttons
  //   setShowNewButtons(true);
  // };
  const [selectedLanguage, setSelectedLanguage] = useState('');
  const SelectLanguageLocal = localStorage.getItem("selectedLanguage");

  useEffect(() => {
    const postVisit = async () => {
      if (!dayId || !unique_day_id || !LearningId || !screenTitleId || !examId) {
        return;
      }

      try {
        const token = localStorage.getItem("AuthToken");
        if (!token) {
          return;
        }

        const response = await fetch(`https://api.japaking.online/api/user-visits/log-visit`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            id: dayId,
            unique_day_id,
            learning_method_id: LearningId,
            screen_title_id: screenTitleId,
            examId,
          }),
        });

        if (!response.ok) {
          throw new Error(`HTTP error: ${response.status}`);
        }
      } catch (error) {
        console.log("Error posting skit visit:", error);
      }
    };

    postVisit();
  }, [dayId, unique_day_id, LearningId, screenTitleId, examId]);

  useEffect(() => {
    const loadLanguage = async () => {
      try {
        const storedLanguage = localStorage.getItem("selectedLanguage");
        console.log("storedLanguage", storedLanguage);
        if (storedLanguage) {
          setSelectedLanguage(storedLanguage);
        }
      } catch (error) {
        console.error("Error loading language:", error);
      }
    };

    loadLanguage();
  }, []);
  return (
    <div className='Profile_Design_Main_Div_11'>
      <div className='header_inner'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12'>
              <ArrowBackIosIcon onClick={() => navigate('/new-learning-journey', { state: { selectedExamId: examId || localStorage.getItem("selectedExamId") || localStorage.getItem("examId"), examId: examId || localStorage.getItem("selectedExamId") || localStorage.getItem("examId"), examTypes: location.state?.examTypes || [] } })} className='icon_1' />
              <ChatBubbleOutlineIcon onClick={() => navigate('/chat-with-staff')} className="logo_1" style={{ cursor: 'pointer', color: '#ffc0cb' }} />
            </div>
          </div>
        </div>
      </div>

      <div
        className="container JLPT_Quiz"
        style={{ marginTop: "75px", marginBottom: "75px", height: "auto" }}
      >
        <div className="container">
          <div className="row">
            {/* Background Voice */}
            <div className="col-md-12">
              <div
                className="background_voice bg-dark"
                onClick={() =>
                  handlePlayPause(currentSkit.audio_summary_url, "summary")
                }
              >
                <p>
                  {Translate?.message?.data?.backgroundVoice || "Background Voice"}{" "}
                  {isPlaying && currentAudio?.textId === "summary" ? (
                    <FaStopCircle size={30} />
                  ) : (
                    <FaPlayCircle size={30} />
                  )}
                </p>

              </div>
            </div>

            {/* Current Skit Image */}
            <div className="col-md-12">
              {loading ? (
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/loading.png`}
                  alt="Loading"
                />
              ) : (
                currentSkit && (
                  <div className="image-container-life-old-Japan-voice">
                    <img src={currentSkit.image_url} alt="Current Skit" />
                  </div>
                )
              )}
            </div>

            {/* Background Audio */}
            <div className="col-md-12 mb-1">
              <div
                className="background_voice bg-dark"
                onClick={() =>
                  handlePlayPause(currentSkit.audio_skit_url, "background")
                }
              >
                <p>
                  {isPlaying && currentAudio?.textId === "background" ? (
                    <FaStopCircle size={30} />
                  ) : (
                    <FaPlayCircle size={30} />
                  )}
                </p>
              </div>
            </div>
          </div>

          {/* Glossary Section */}
          <div className="col-md-12">
            {/*             
            {SelectLanguageLocal === "hindi" ? (
                             <h3 className="glossary-heading">शब्दकोष</h3>
                        ) : (
                          <h3 className="glossary-heading">Glossary</h3>
                        )} */}
            {currentSkit?.skit?.map((textItem) => (
              <div className="Voice_Card" key={textItem.text_id}>
                {textItem?.kanji && <p>{textItem.kanji}</p>}
                {textItem?.hiragana && <p>{textItem.hiragana}</p>}
                {textItem?.hiragana_eng && <p>{textItem.hiragana_eng}</p>}
                {textItem?.english && <p>{textItem.english}</p>}

                {/* Play/Pause Button */}
                <div
                  className="video_icon"
                  onClick={() =>
                    handlePlayPause(textItem.skit_content.audio_url, textItem.text_id)
                  }
                >
                  {isPlaying && currentAudio?.textId === textItem.text_id ? (
                    <FaStopCircle size={30} />
                  ) : (
                    <FaPlayCircle size={30} />
                  )}
                </div>
              </div>
            ))}
          </div>

          {/* Next Day and Quiz Buttons */}
          <div className="row">
            {/* Next Day Button */}
            <div className="d-flex flex-column align-items-center w-100">
              {isLastSkit ? (
                <>
                  {/* Render buttons if it's the last skit */}
                  <div className="mb-2 w-100">
                    <button
                      onClick={() =>
                        navigate('/ModuleThanks', {
                          state: {
                            dayId,
                            unique_day_id,
                            LearningId,
                            screenTitleId,
                            examId,
                            examTypes: location.state?.examTypes || [],
                          }
                        })
                      }
                      className="next-button-life-old-Japan-voice wide-button"
                    >
                      {Translate?.message?.data?.nextDay || "Next Day"}
                    </button>
                  </div>
                  <div className="mb-2 w-100">

                  </div>
                  <div className="mb-2 w-100">

                  </div>
                </>
              ) : (
                <>
                  {/* Render Next Day button or Loading state */}
                  {isLoading ? (
                    <div className="mb-2 w-100">
                      <button className="next-button-life-old-Japan-voice wide-button" disabled>
                        Loading...
                      </button>
                    </div>
                  ) : (
                    <div className="mb-2 w-100">
                      <button
                        onClick={handleNext}
                        className="next-button-life-old-Japan-voice wide-button"
                      >
                        {Translate?.message?.data?.nextDay || "Next Day"}
                      </button>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* Footer Section */}
            <Footer />
    </div >
  );
};

export default ModuleSkit;
